export default __webpack_public_path__ + "static/media/logo-dubbing-en-v3.3f35f222.svg";